import { last } from 'lodash';
import { table } from '../quizApp.style';

function ShowAnswers(props) {
  return (
    <div className="table-responsive">
      <table className={table}>
        <tbody>
          <tr>
            <th>Questions</th>
            <th>Correct Answer</th>
            <th>Selected Answer</th>
            <th>Result</th>
          </tr>
          {Object.entries(props.useranswers).map((value) => {
            const parsedValue = JSON.parse(last(value));
            return (
              <tr>
                <td>{parsedValue.question}</td>
                <td>{parsedValue.correctanswer}</td>
                <td>{parsedValue.useranswer}</td>
                <td>
                  {parsedValue.correctanswer.replace('Spell', '').trim() ==
                  parsedValue.useranswer.trim() ? (
                    <img height="40" width="40" src="../assets/pass.png" />
                  ) : (
                    <img height="40" width="40" src="../assets/fail.png" />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ShowAnswers;
